import { render, staticRenderFns } from "./DeleteIcon.vue?vue&type=template&id=322d32f2&scoped=true&"
import script from "./DeleteIcon.vue?vue&type=script&lang=ts&"
export * from "./DeleteIcon.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteIcon.vue?vue&type=style&index=0&id=322d32f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322d32f2",
  null
  
)

export default component.exports